/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['mainConfig'], function(mainConfig) {
    var productInfo;
    var sdkInfo = mainConfig['analytics.header.sdkName'] + '/' + mainConfig['sdk.version'];
    var headerName = mainConfig['analytics.header.name'];

    return {
        getHeaderName: function() {
            return headerName;
        },
        getHeaderContent: function() {
            var prodInfo = productInfo !== undefined ? ' ' + productInfo : '';
            return sdkInfo + prodInfo;
        },

        setProductInfo: function(productId, productVersion) {
            var prodVersion;
            if (!productId) {
                throw new Error('ProductId needs to be set');
            }
            prodVersion = productVersion || productVersion === 0 ? '/' + productVersion : '';
            productInfo = productId + prodVersion;
        },
        getProductInfo: function() {
            return productInfo;
        },
        addAnalyticsHeader: function(req) {
            req.header(headerName, this.getHeaderContent());
            return req;
        },
        getAnalyticsHeader: function() {
            var header = {};
            header[headerName] = this.getHeaderContent();
            return header;
        },
        customCreateTile: function(coords, done, layer) {
            var tile = document.createElement('img');
            var tileUrl = layer.getTileUrl(coords);
            var errorTileUrl = layer.options && layer.options.errorTileUrl;

            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        tile.src = URL.createObjectURL(xhr.response); //create <img> with src set to the blob
                    } else if (errorTileUrl) {
                        tile.src = errorTileUrl;
                    }
                    done(null, tile);
                }
            };
            xhr.open('GET', tileUrl, true);
            // don't set responseType before calling open(), this will cause an invalid state error under IE11
            xhr.responseType = 'blob'; //so you can access the response like a normal URL
            xhr.setRequestHeader(this.getHeaderName(), this.getHeaderContent());
            xhr.send();
            if (layer.options.crossOrigin) {
                tile.crossOrigin = '';
            }

            /*
             Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
             http://www.w3.org/TR/WCAG20-TECHS/H67
            */
            tile.alt = '';
            tile.setAttribute('original-src', tileUrl);
            /*
             Set role="presentation" to force screen readers to ignore this
             https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
            */
            tile.setAttribute('role', 'presentation');
            return tile;
        }
    };
});



// WEBPACK FOOTER //
// ./requester/analytics.js